<template>
  <div class="centered-item-block">
    <div class="row-3-custom p-top-9 p-bot-7">
      <div class="centered-item-block-container">
        <NuxtLink
          :to="
            localePath({
              name: 'risorse',
            })
          "
          v-if="showBackButton"
        >
          <div class="text-medium5 default-icon-btn is-medium-bold is-reversed">
            <ArrowIcon alt="Arrow icon" class="icon-arrow" />
            <span v-html="$t('common.indietro')" />
          </div>
        </NuxtLink>
        <div class="centered-item-block__intro">
          <h1 class="title-medium3 is-medium-bold" v-html="item.title" />
        </div>
        <div v-for="(item, index) in item.sezioneContenutoPagina" :key="index">
          <div v-if="item.__typename === 'immagine_Entry'">
            <div
              class="centered-item-block__image"
              v-if="item.custom.length > 0"
            >
              <WidgetPicture
                :image="{
                  custom: item.custom?.[0],
                }"
                :alt="item.custom?.[0]?.title"
              />
            </div>
          </div>
          <div v-else-if="item.__typename === 'testo_Entry'">
            <div class="centered-item-block__text text-editorial">
              <div class="text-medium5" v-html="item.text" />
            </div>
          </div>
          <div v-else-if="item.__typename === 'immagineTradotta_Entry'">
            <div
              class="centered-item-block__image"
              v-if="item.custom.length > 0"
            >
              <WidgetPicture
                :image="{
                  custom: item.custom?.[0],
                }"
                :alt="item.custom?.[0]?.title"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  showBackButton: {
    type: Boolean,
    default: true,
  },
})
</script>

<script>
export default {
  name: 'CenteredContent',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
